export const defaultSelectValue = {
  "key": "",
  "value": "Bitte wählen..."
};
